(function (root, doc) {
    'use strict';
    var parsed = root.PewniakiI18nData;
    var dictionary = parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};

    function replace(text, params) {
        if (!params) return text;
        if (Array.isArray(params)) {
            return params.reduce(function (out, value, index) {
                return out.split('%' + (index + 1)).join(String(value));
            }, text);
        }
        Object.keys(params).forEach(function (key) {
            text = text.split('%' + key + '%').join(String(params[key]));
        });
        return text;
    }

    root.PewniakiI18n = Object.freeze({
        t: function (key, params) {
            var text = Object.prototype.hasOwnProperty.call(dictionary, key) ? String(dictionary[key]) : String(key);
            return replace(text, params);
        },
        has: function (key) {
            return Object.prototype.hasOwnProperty.call(dictionary, key);
        }
    });
    try { delete root.PewniakiI18nData; } catch (ignore) {}
}(typeof globalThis !== 'undefined' ? globalThis : this, typeof document !== 'undefined' ? document : null));
